export const environment = {
    production: false,
    urlNonce: 'https://backoffice-databeer.staging.ccdatos.com',
    googleAPIKey: 'AIzaSyBimWkFQeM-RKzGbGLZKoW14tOeLdr43kA', // [AÑADIR AQUÍ LA API KEY DE GOOGLE MAPS PARA DESARROLLO]
    enKey: 'pbqMUNPTHjQ7dv8v',
    msal: {
        clientId: '4781df1d-128a-480d-a7eb-66d99637092e',
        authority: 'https://login.microsoftonline.com/b5705db2-024e-4c46-af5f-151a1d799673',
        // redirectUri: 'http://localhost:4200/login',
        redirectUri: 'https://frontend-databeer.staging.ccdatos.com/login',
        scopes: ['openid', 'profile', 'email']
    }
};
